import {
  Box, Link, makeStyles, Typography,
} from '@material-ui/core';
import React from 'react';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'nowrap',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    marginBottom: theme.spacing(2),
  },
  copyright: {
    fontSize: '0.8rem',
  },
}));

export const Footer = (): JSX.Element => {
  const classes = useStyles();
  return (
    <Box className={classes.root}>
      <Typography color="textSecondary" className={classes.copyright}>
        Copyright © 2020 Pascal Heitz. All rights reserved. |{' '}
        <Link href="/privacy-policy">Privacy Policy</Link> |{' '}
        <Link href="/credits">Credits</Link>
      </Typography>
    </Box>
  );
};
